import styled, { css } from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';

export const LinkDesktop = styled(Button)(
  props => css`
    width: 100%;
    white-space: normal;
    text-transform: none;
    padding: ${layout.spacing.xSmall} 0 ${layout.spacing.xSmall}
      ${layout.spacing.xSmall};

    ${media.mediumDown`
    display: none;
  `}
  `
);

export const LinkMobile = styled(Button)(
  props => css`
    color: ${props.theme.buttons.positive.bg};
    padding: 5px 2px;

    ${media.largeUp`
    display: none;
  `}
  `
);

type StoreLinkProps = {
  disabled?: boolean;
  visible?: boolean;
};

export const StoreLink = styled.div<StoreLinkProps>(
  props => css`
    width: 100%;
    visibility: ${props.visible ? 'visible' : 'hidden'};

    ${props.disabled &&
      css`
        ${LinkDesktop} {
          color: ${p => p.theme.text.tertiary};
          font-weight: normal;
          text-transform: none;
        }
      `}

    ${media.smallOnly`
      padding: 5px 0 5px ${layout.spacing.xSmall};
    `}
  `
);
